<template>
  <div class="about-us">
    <div class="about-us-banner">
      <img :src="loadUrl.banner_bg" />
      <div>关于我们</div>
    </div>
    <div class="about-us-content">
      <div class="introduce">
        <div>公司介绍</div>
        <div>
          <div>混空是一家专注元宇宙数实融合场景建设的公司，深耕XR+AI技术突破，为文娱、商业、工业、教育行业提供综合解决方案。</div>
          <div>混空自研多项核心底层技术，专注于视觉+AI算法融合，实现厘米级空间定位。核心产品混空 Studio（智能体）是一款AI+AR元宇宙内容创作与分发平台，帮助用户一站式完成空间数字化建模和元宇宙互动营销场景创作，并通过XR眼镜、手机等实现跨端数实融合体验。</div>
          <div>公司获得国家级高新技术企业认定、国家双软企业认定和国家科技型中小企业认定，已申请70多项知识产权，并凭借数实融合技术多次斩获国内投资价值类奖项，成为元宇宙头部公司。</div>
        </div>
      </div>
      <div class="company-profile">
        <img :src="loadUrl.company_profile" />
      </div>
      <!-- <div class="honor">
          <div class="title">荣誉及资质</div>
        </div> -->
      <div class="ryzz honor">
        <div class="title">荣誉资质</div>
        <div class="ryzz-list">
          <div class="ryzz-viewport">
            <el-carousel :interval="3000" type="card" height="400rem" :arrow="'always'" :autoplay="false" :indicator-position="'none'">
              <el-carousel-item v-for="(item, index) in honors" :key="index">
                <div class="honors-card">
                  <img :src="item.url" />
                  <div class="honors-text">
                    <div v-for="(e, i) in item.illustrate" :key="i">{{ e }}</div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="xwzx">
        <div class="title-font-style title">公司动态</div>
        <div class="xwzx-box">
          <div class="news-content">
            <div v-for="(e, i) in newsList" :key="i" @click="toOtherPath(e.relatedHtmlId, e.title)"
              :class="activeNewsIndex == i ? 'active' : ''">
              <div>{{ e.title }}</div>
              <div>{{ e.times }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, watch, onMounted, onUnmounted, reactive } from 'vue'
import { selectCommonElement, addConsult } from '@/api'
import router from '@/router';
import { ElCarousel, ElCarouselItem } from 'element-plus'
import { asynchronousRetrieval } from '@/utils'
const loadUrl: any = ref({})

let timer3: any = null;
const newsList: any = ref([])
const honors = [
  {
    url: require('@/assets/images/about_us/ryzz8.jpg'),
    illustrate: ['高新技术企业']
  },
  {
    url: require('@/assets/images/about_us/ryzz1.png'),
    illustrate: ['2023上海最具投资潜力']
  },
  {
    url: require('@/assets/images/about_us/ryzz2.png'),
    illustrate: ['“创客中国”元宇宙（人工智能）']
  },
  {
    url: require('@/assets/images/about_us/ryzz3.png'),
    illustrate: ['2023数智创新优胜奖']
  },
  {
    url: require('@/assets/images/about_us/ryzz6.png'),
    illustrate: ['2024年度典型案例']
  },
  {
    url: require('@/assets/images/about_us/ryzz7.png'),
    illustrate: ['上海市创新创业大赛 优胜奖']
  },
]

const activeNewsIndex = ref(0)


const toOtherPath = (relatedHtmlId: number, title: string) => {
  router.push(`/details?relatedHtmlId=${relatedHtmlId}`)
}

onMounted(async () => {
  selectCommonElement({ columnId: 5, appId: 2 }).then((res: any) => {
    newsList.value = [...res].sort((a: any, b: any) => (a.sortNum ?? 0) - (b.sortNum ?? 0)).slice(0, 4).map((e: any) => {
      const date = new Date(e.newsTimestamp || e.createTime)
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      e.times = `${y}-${m}-${d}`
      return e;
    })
  })

  clearInterval(timer3)
  timer3 = setInterval(() => {
    activeNewsIndex.value += 1;
    if (activeNewsIndex.value > 3) {
      activeNewsIndex.value = 0;
    }
  }, 3000)

  const particle_moment_mp4: any = await asynchronousRetrieval('webimg/images/home/particles-moment.mp4');
  const banner_bg: any = await asynchronousRetrieval('webimg/images/about_us/banner-bg.png');
  const company_profile: any = await asynchronousRetrieval('webimg/images/about_us/company-profile.png');
  loadUrl.value = { particle_moment_mp4, banner_bg, company_profile }
})

onUnmounted(() => {
  clearInterval(timer3)
})


</script>
<style scoped lang="less">
.about-us-banner {
  position: relative;
  height: 208rem;
  line-height: 208rem;
  text-align: center;
  font-weight: 600;
  font-size: 40rem;
  color: #FFFFFF;

  img {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
  }

  &>div {
    position: relative;
    z-index: 1;
  }
}

.about-us-content {
  background: #F6FAFF;
  padding-top: 48rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: left;

  .introduce {
    padding: 0 75rem;
    box-sizing: border-box;

    &>div:first-child {
      font-size: 40rem;
      color: #000000;
      line-height: 56rem;
      margin-bottom: 18rem;
    }

    &>div:last-child {
      font-weight: 400;
      font-size: 20rem;
      color: #5D5D5D;
      line-height: 30rem;

      &>div {
        margin-bottom: 38rem;
      }
    }
  }

  .company-profile {
    margin-top: 20rem;

    img {
      width: 600rem;
      height: 216rem;
    }
  }

  .title {
    font-size: 40rem;
    color: #000000;
    text-align: left;
    padding-left: 76rem;
  }

  .honor {
    margin-top: 66rem;
  }
}

.ryzz {
  position: relative;
  width: 750rem;
  display: inline-block;

  .title {
    padding-left: 76rem;
    font-size: 40rem;
    color: #000000;
    line-height: 56rem;
  }

  .ryzz-list {
    position: relative;
    width: 100%;
    height: 400rem;
    margin-top: 48rem;
    z-index: 0;

    .ryzz-viewport {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    :deep(.el-carousel) {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    :deep(.el-carousel__container) {
      height: 400rem;
      overflow: hidden;
    }

    :deep(.el-carousel__item) {
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: transform .5s ease, opacity .35s ease;
    }

    :deep(.el-carousel__item.is-in-stage) {
      opacity: 1;
    }

    :deep(.el-carousel__item.is-active) {
      opacity: 1;
    }

    :deep(.el-carousel__item.is-active .honors-card) {
      box-shadow: 7px 6rem 7rem rgb(152 160 174 / 18%), 0 6rem 14rem rgba(15, 23, 42, 0.08);
    }

    :deep(.el-carousel__item:not(.is-in-stage)) {
      opacity: 0;
      pointer-events: none;
    }

    .honors-card {
      position: relative;
      width: 232rem;
      height: 270rem;
      border-radius: 6rem;
      padding-bottom: 50rem;
      box-sizing: border-box;
      text-align: center;
      border: 1px solid #D8D8D8;
      background: transparent;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      transition: box-shadow .35s ease;

      img {
        width: 168rem;
        height: auto;
        object-fit: contain;
      }

      .honors-text {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 68rem;
        padding: 15rem 0;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        box-sizing: border-box;
        background-color: #2E76FF;
        font-weight: bold;
        font-size: 14rem;
        color: #FFFFFF;
        line-height: 28rem;
        border-radius: 0 0 8rem 8rem;

        div {
          width: 100%;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

.xwzx {
  width: 750rem;

  .more-box {
    font-weight: 400;
    font-size: 18rem;
    color: #D81417;
    font-family: PingFangSC-Medium;
    margin-top: 20rem;

    &>div {
      display: inline-block;
      cursor: pointer;
    }

    span {
      vertical-align: middle;
    }

    img {
      width: 6rem;
      height: 11rem;
      vertical-align: middle;
      margin-left: 6rem;
    }

    padding-bottom: 73rem;
  }

  .xwzx-box {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 48rem;
    box-sizing: border-box;
    font-size: 0;
    padding: 0 58rem 0 74rem;

    .news-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;

      &>div {
        text-align: left;
        font-family: PingFangSC-Medium;
        font-weight: bold;
        color: #414141;
        margin-bottom: 48rem;

        &>div:first-child {
          font-weight: 500;
          font-size: 28rem;
          line-height: 40rem;
        }

        &>div:last-child {
          font-weight: 400;
          font-size: 20rem;
          margin-top: 8rem;
        }
      }
    }
  }
}

.bg-video {
  position: relative;
  // width: 1920rem;
  height: 620rem;

  video {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }

  .contact-us {
    width: 1266rem;
    height: 396rem;
    background: rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.1);
    background-clip: padding-box;
    backdrop-filter: blur(6rem);
    position: absolute;
    left: 50%;
    top: 120rem;
    margin-left: -633rem;
    border-radius: 12rem;
    padding: 62rem 72rem;
    box-sizing: border-box;

    .title {
      font-weight: 500;
      font-size: 32rem;
      color: #D3D3D3;
    }

    .form-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 59rem;

      &>div {
        position: relative;
        width: 267rem;
        height: 40rem;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 8rem;
      }
    }

    .submit-btn {
      width: 152rem;
      height: 56rem;
      line-height: 56rem;
      background: #0675FF;
      border-radius: 8rem;
      text-align: center;
      font-weight: 500;
      font-size: 24rem;
      color: #FFFFFF;
      margin-top: 80rem;
      margin-left: 470rem;
      cursor: pointer;
    }
  }

  .contact-service {
    position: relative;
    width: 1266rem;
    height: 396rem;
    position: absolute;
    left: 50%;
    top: 120rem;
    margin-left: -633rem;
    border-radius: 12rem;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 12rem;
    border: 1px solid #464646;
    backdrop-filter: blur(12rem);
    padding: 40rem 87rem;
    box-sizing: border-box;

    .title {
      font-weight: 500;
      font-size: 32rem;
      color: #fff;
    }

    .title-tips {
      font-weight: 400;
      font-size: 14rem;
      color: #FFFFFF;
      margin-top: 12rem;
      margin-bottom: 50rem;
    }

    .service-list {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &>div:first-child {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        font-weight: 400;
        font-size: 14rem;
        color: #FFFFFF;

        img {
          width: 123rem;
          height: 123rem;
          margin-bottom: 6rem;
        }
      }

      &>div {
        width: 356rem;
        height: 187rem;
        background: #151515;
        border-radius: 12rem;
        border: 1px solid #4A4A4A;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: 40rem 0;
        box-sizing: border-box;

        .fontBold {
          font-weight: bold;
          font-size: 20rem;
          color: #FFFFFF;
        }

        .fontNormal {
          font-weight: 500;
          font-size: 14rem;
          color: #7C7C7C;
        }

      }
    }

    .closed {
      width: 30rem;
      height: 30rem;
      background: url(~@/assets/images/home/close.png);
      background-size: 100% 100%;
      position: absolute;
      right: 30rem;
      top: 25rem;
      cursor: pointer;
    }
  }
}
</style>
